export default __webpack_public_path__ + "static/media/png-dropdown.e75abf3f.webp";